import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative z-10 bg-[#050505] border-t border-white/10 pt-20 pb-10">
    <div className="mx-auto max-w-7xl px-5 lg:px-10 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="font-serif text-2xl text-white">
          GOLDEN <span className="gold-text">CAB</span>
        </div>
        <p className="text-xs tracking-[0.35em] text-white/40 mt-1">TRANSPORT</p>
        <p className="mt-6 text-sm text-white/50 max-w-xs leading-relaxed">{COMPANY.tagline}</p>
      </div>

      <div>
        <h4 className="text-sm font-medium text-gold mb-5 tracking-wide">Navigation</h4>
        <ul className="space-y-3 text-sm text-white/60">
          <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
          <li><Link to="/services" className="hover:text-white transition-colors">Services & Tarifs</Link></li>
          <li><Link to="/flotte" className="hover:text-white transition-colors">Notre Flotte</Link></li>
          <li><Link to="/reservation" className="hover:text-white transition-colors">Réservation</Link></li>
          <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-medium text-gold mb-5 tracking-wide">Légal</h4>
        <ul className="space-y-3 text-sm text-white/60">
          <li><Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-white transition-colors">Mentions Légales</Link></li>
          <li><Link to="/cgv" data-testid="footer-cgv" className="hover:text-white transition-colors">CGV</Link></li>
          <li><Link to="/cgu" data-testid="footer-cgu" className="hover:text-white transition-colors">CGU</Link></li>
          <li><Link to="/admin" className="hover:text-white transition-colors">Espace Admin</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-medium text-gold mb-5 tracking-wide">Contact</h4>
        <ul className="space-y-4 text-sm text-white/60">
          <li className="flex gap-3"><MapPin size={16} className="text-gold shrink-0 mt-0.5" /><span>{COMPANY.address}</span></li>
          <li className="flex gap-3"><Clock size={16} className="text-gold shrink-0 mt-0.5" /><span>{COMPANY.hours}</span></li>
          <li className="flex gap-3"><Phone size={16} className="text-gold shrink-0 mt-0.5" /><span>Réservation en ligne 24/7</span></li>
        </ul>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-5 lg:px-10 mt-16">
      <div className="gold-hairline mb-8" />
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <p>© {new Date().getFullYear()} {COMPANY.name} — {COMPANY.legalForm.split(" (")[0]}. Tous droits réservés.</p>
        <p>RCS {COMPANY.rcs} · Capital {COMPANY.capital}</p>
      </div>
    </div>
  </footer>
);
